import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useLang } from "@/lib/i18n";

const LAYOUTS = [
  { key: "kino", nn: "Kino", en: "Theatre" },
  { key: "skule", nn: "Skule", en: "Classroom" },
  { key: "styrebord", nn: "Styrebord", en: "Boardroom" },
  { key: "bankett", nn: "Bankett", en: "Banquet" },
];

const cell = (v) => (v == null ? "–" : v);

/**
 * Accessible meeting-room capacity table (shadcn Table). On phones the table scrolls horizontally
 * inside its own frame so it never pushes the page wider than 390px.
 */
export const CapacityTable = ({ rooms = [], testid = "arrangement-capacity-table", combined }) => {
  const { tx } = useLang();
  const rows = [...rooms, ...(combined ? [combined] : [])];
  return (
    <div className="min-w-0 max-w-full overflow-hidden rounded-[22px] border border-border bg-card" data-testid={testid}>
      <div className="overflow-x-auto">
        <Table className="min-w-[560px]">
          <TableHeader>
            <TableRow className="bg-secondary/70 hover:bg-secondary/70">
              <TableHead className="h-12 px-5 text-xs font-semibold uppercase tracking-wide text-muted-foreground">{tx("Rom", "Room")}</TableHead>
              <TableHead className="h-12 text-right text-xs font-semibold uppercase tracking-wide text-muted-foreground">m²</TableHead>
              {LAYOUTS.map((l) => (
                <TableHead key={l.key} className="h-12 text-right text-xs font-semibold uppercase tracking-wide text-muted-foreground">{tx(l.nn, l.en)}</TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.id || r.name} className="hover:bg-secondary/40" data-testid={`${testid}-row-${r.id || "combined"}`}>
                <TableCell className="px-5 py-4 font-semibold text-foreground">{r.name}</TableCell>
                <TableCell className="py-4 text-right tnum text-foreground">{cell(r.area_m2)}</TableCell>
                {LAYOUTS.map((l) => (
                  <TableCell key={l.key} className="py-4 text-right tnum text-foreground">{cell(r.capacity?.[l.key])}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <p className="border-t border-border px-5 py-3 text-xs text-muted-foreground">{tx("Tal personar per oppsett. Skåno og Peparen kan slåast saman til eitt lokale.", "Number of people per layout. Skåno and Peparen can be combined into one venue.")}</p>
    </div>
  );
};
